import ButtonProfile from './ButtonProfile'

export default ButtonProfile
